<template>
    <common-modal v-if="isOpen" width="medium" @close="emitEvent({ name: 'close' })">
        <common-content-wrapper width="small">
            <common-content-spacer height="large">
                <common-page-header
                    :heading="$t('modals.remove_practice_member_modal.heading', { name: userFullName })"
                    :content="$t('modals.remove_practice_member_modal.content', { name: userFullName })"
                    :isCenter="true"
                    contentSpacing="medium"
                ></common-page-header>

                <common-buttons>
                    <common-button
                        :label="$t('common.microcopy.cancel')"
                        :isProcessing="isProcessing"
                        type="secondary"
                        size="large-long"
                        @click="emitEvent({ name: 'close' })"
                    ></common-button>
                    <common-button
                        :label="$t('common.microcopy.confirm')"
                        :isProcessing="isProcessing"
                        type="primary"
                        size="large-long"
                        @click="removeMember"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    import UsersAPI from 'api/UsersAPI'

    export default {
        props: {
            isOpen: { type: Boolean, required: true },
            user: { type: Object, required: true },
        },

        data() {
            return {
                isProcessing: false,
            }
        },

        computed: {
            userFullName() {
                return `${this.user.firstName} ${this.user.lastName}`
            },
        },

        methods: {
            removeMember() {
                this.isProcessing = true
                UsersAPI.removePracticeMember({ userId: this.user.id }).then(() => {
                    this.emitEvent({ name: 'member-removed', payload: this.user })
                    this.isProcessing = false
                })
            },
        },
    }
</script>
